// Mirrors `widgets/chatbot/src/utils/linkUtils.ts` — duplicated rather
// than imported so each widget bundles only what it needs. If you
// change one, mirror the change here. The chatbot copy has a wider
// surface (`isSafeImageUrl`, `getLinkTarget`) — only `isSafeNavigationUrl`
// is required in the search widget today.

const SAFE_NAV_SCHEMES = new Set(['http:', 'https:', 'mailto:', 'tel:']);

function stripControlAndWhitespacePrefix(url: string): string {
  // biome-ignore lint/suspicious/noControlCharactersInRegex: matches the HTML URL-attribute leading-control-char strip
  return url.replace(/^[\x00-\x1F\x20]+/, '');
}

/**
 * `true` if a URL is safe to navigate to. Rejects `javascript:`,
 * `data:*`, `vbscript:`, etc. Relative paths and fragments pass through.
 */
export function isSafeNavigationUrl(url: string): boolean {
  if (!url) return false;
  const trimmed = stripControlAndWhitespacePrefix(url);
  if (trimmed === '#' || trimmed.startsWith('#')) return true;
  if (trimmed.startsWith('/') || trimmed.startsWith('./') || trimmed.startsWith('../')) return true;
  if (trimmed.startsWith('//')) return true;
  try {
    const parsed = new URL(trimmed, window.location.href);
    return SAFE_NAV_SCHEMES.has(parsed.protocol.toLowerCase());
  } catch {
    return false;
  }
}
